import { ApiState } from "infrastructure/api";
import { createSlice } from "infrastructure/store/lib";
import initialState, { sliceToken } from "./state";

const slice = createSlice({
    name: sliceToken,
    initialState,
    reducers: {
        changePspKycSettingsLoadingState: (state, { payload }) => {
            state.settings.tableLoadingState = payload;
        },
        changePspKycSettingsSlice: (state, { payload }) => {
            state.settings.tableSlice = payload.data;
        },
        resetPspKycSettings: state => {
            state.settings.tableSlice = null;
            state.settings.tableLoadingState = ApiState.Idle;
        }
    }
});

export const {
    name,
    actions: {
        changePspKycSettingsLoadingState,
        changePspKycSettingsSlice,
        resetPspKycSettings
    }
} = slice;

export default slice.reducer;
